import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faInfoCircle,
  faFileAlt,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);


  const navItems = [
    { name: "Home", path: "/home", icon: faHome },
    { name: "About", path: "/about", icon: faInfoCircle },
    { name: "Resume", path: "/resume", icon: faFileAlt },
    { name: "Achievements", path: "/achievements", icon: faTrophy },
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar-container">
      <div className="navbar-logo">Sumit.dev</div>

      <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            <FontAwesomeIcon icon={item.icon} className="nav-icon" fixedWidth />
            {item.name}
          </NavLink>
        ))}
      </div>

      <div className="navbar-toggle" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

export default Navbar;
